import { render } from "./GiftCheckoutResult.vue?vue&type=template&id=64efd483"
import script from "./GiftCheckoutResult.vue?vue&type=script&lang=js"
export * from "./GiftCheckoutResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__